import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { assetsClient } from '#pplx_generated/typespec/rest/assets/client.js';
export const unpinFile = async ({ assetId, reason, }) => {
    const { data, error, response } = await assetsClient.DELETE('/rest/assets/pins/{asset_id}', reason, {
        params: { path: { asset_id: assetId } },
        timeoutMs: getQueryTimeoutMs(),
        numRetries: 0,
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to unpin file',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=unpinFile.js.map